export default __webpack_public_path__ + "static/media/Fresca-Event.a0228074.jpg";